import { ContainerNav } from "../style/style";
import { NB_HorizontalMenuProps } from "../types/horizontalMenu.type";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../theme";
const useStyles = makeStyles((theme) => ({
  appBar: {
    // Ajustes adicionales si lo deseas
  },
  toolbar: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    padding: 0,
    marginTop: "24px",
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
  },
  tabsContainer: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#fff",
    borderRadius: "8px",
  },

  tabs: {
    marginInline: theme.spacing(1),
    color: colors.blue,
    "& .MuiTabs-indicator": {
      backgroundColor: colors.blue,
      justifyContent: "center",
      height: 3, // thickness
      borderTopRightRadius: 2,
      borderTopLeftRadius: 2,
    },
    "& .MuiTab-root": {
      color: colors.blue,
      "&.Mui-selected": {
        color: colors.blue,
      },
    },
  },
  tab: {
    fontSize: "14px",
    textTransform: "none",
    fontWeight: 500,
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
  },
  searchInput: {
    marginLeft: theme.spacing(2),
    backgroundColor: "#fff",
    width: "100%",
    height: "36px",
    textTransform: "none",
  },
  searchButton: {
    marginLeft: 4,
    textTransform: "none",
  },
  title: {
    color: colors.blue,
    fontSize: "32px",
    margin: 0,
    padding: 0,
  },
  newTemplateButton: {
    marginLeft: "20px",
    textTransform: "none",
  },
}));
export const HorizontalMenuView = (props: Partial<NB_HorizontalMenuProps>) => {
  const { onClickMenuFn = () => {}, pageActive } = props;
  const classes = useStyles();
  return (
    <ContainerNav>
      <div className={classes.tabsContainer}>
        <Tabs value={pageActive ?? 0} className={classes.tabs}>
          {props.menu?.map((item, index: number) => (
            <Tab
              key={item.id}
              label={item.name}
              className={classes.tab}
              onClick={() => {
                onClickMenuFn(item);
              }}
            />
          ))}
        </Tabs>
      </div>
    </ContainerNav>
  );
};
